<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-users">
      {{ group.name }}
    </page-title>

    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-text>
          <group-form :form="form"
                      :group="group">
          </group-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <v-btn
              @click.prevent="submit"
              :disabled="form.busy"
              color="primary">
              Save
            </v-btn>
            <v-btn :to="{name: 'admin.groups.index'}"
                   exact>
              Cancel
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn @click.prevent="deleteGroup"
                 :disabled="group.is_all_users"
                 color="error">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>

import {orderBy} from 'lodash';
import GroupForm from "./components/GroupForm";
import {mapGetters} from 'vuex';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, GroupForm},
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    this.$store.commit('setTitle', `Edit Group: ${this.group.name}`);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Groups', exact: true, to: {name: 'admin.groups.index'},},
        {text: 'Edit Group'},
      ],
      form: new Form({
        name: this.group.name,
        presentations: orderBy(this.group.presentations, ['slug']).map(p => p.id),
        users: orderBy(this.group.users, ['slug']).map(u => u.id),
        templates: orderBy(this.group.templates, ['slug']).map(t => t.id),
      })
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'groups',
      'presentations',
      'team',
      'users',
      'shareTemplates',
    ]),
  },
  methods: {
    async submit() {
      if (this.form.busy) {
        return;
      }
      this.form.put(`/api/groups/${this.group.id}`)
        .then(response => {
          this.$toast.success('Group updated.');
          this.$store.dispatch('fetchGroups');
          this.$emit('updated');
          this.$router.push({name: 'admin.groups.index'});
        })
        .catch(err => {

        });
    },
    async deleteGroup() {
      if (this.form.busy) {
        return;
      } else if (this.group.is_all_users) {
        this.$toast.error('You cannot delete this group.');
        return;
      }
      if (confirm('Are you sure you want to delete this group?')) {
        this.form.delete(`/api/groups/${this.group.id}`)
          .then(response => {
            this.$toast.success('Group Deleted.');
            this.$store.dispatch('fetchGroups');
            this.$router.push({name: 'admin.groups.index'});
          })
          .catch(err => {
            this.$toast.error(err);
          });
      }
    },
  }
}
</script>

